import React, { createContext, useContext } from "react";
import { ContactModel } from "@/apidtos";

interface PaymentContactsContextValue {
  contacts: ContactModel[];
  billingContactId?: number;
}

const PaymentContactsContext = createContext<PaymentContactsContextValue | undefined>(undefined);

interface PaymentContactsProviderProps {
  contacts: ContactModel[];
  billingContactId?: number;
  children: React.ReactNode;
}

export const PaymentContactsProvider = ({ contacts, billingContactId, children }: PaymentContactsProviderProps) => {
  return (
    <PaymentContactsContext.Provider value={{ contacts, billingContactId }}>
      {children}
    </PaymentContactsContext.Provider>
  );
};

export const usePaymentContacts = () => {
  const context = useContext(PaymentContactsContext);
  if (context === undefined) {
    throw new Error("usePaymentContacts must be used within a PaymentContactsProvider");
  }
  return context;
};
